import { useDebouncedCallback } from '@fabric-app/hooks/useDebouncedCallback';
import { useColorScheme } from './useColorScheme.js';
import React__default from 'react';

const useColorSchemeToggleKbd = () => {
  const { toggleColorScheme } = useColorScheme();
  const toggleColorSchemeDebounced = useDebouncedCallback(toggleColorScheme, 200);
  const toggleColorSchemeDebouncedRef = React__default.useRef(toggleColorSchemeDebounced);
  toggleColorSchemeDebouncedRef.current = toggleColorSchemeDebounced;
  React__default.useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.code === "KeyT" && event.shiftKey && event.altKey && event.ctrlKey) {
        toggleColorSchemeDebouncedRef.current(true);
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);
};

export { useColorSchemeToggleKbd };
//# sourceMappingURL=useColorSchemeToggleKbd.js.map
